module.exports = __webpack_public_path__ + "static/img/gyq.df10d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/gyq.png
// module id = Dcyk
// module chunks = 43